// extracted by mini-css-extract-plugin
module.exports = {"whiteboardBrushSize":"WhiteboardBrushSize_whiteboardBrushSize__2deKv","size":"WhiteboardBrushSize_size__o7vsk","sizeInput":"WhiteboardBrushSize_sizeInput__3yFYh"};